<template>
  <v-container fluid class="pa-4 rtl">
    <!-- Header -->
    <v-card class="header-card mb-4" elevation="2">
      <div class="d-flex align-center justify-space-between flex-wrap ga-3">
        <div>
          <div class="text-h5 font-weight-bold" style="color: #4a4f55">
            تصنيف أولوية إعادة التأهيل والتكلفة
          </div>
          <div class="text-body-2 text-grey-darken-1 mt-1">
            تقدير التكاليف وتصنيف الأولوية لكل مرفق
          </div>
        </div>
        <v-btn
          prepend-icon="mdi-arrow-right"
          variant="text"
          style="color: #4a4f55"
          @click="showView('pillar-infra')"
        >
          رجوع
        </v-btn>
      </div>
    </v-card>

    <!-- KPIs -->
    <v-row class="mb-4">
      <v-col cols="12" sm="6" md="3">
        <v-card class="kpi-card danger">
          <div class="kpi-value">$4.2M</div>
          <div class="kpi-label">إجمالي التكاليف</div>
        </v-card>
      </v-col>
      <v-col cols="12" sm="6" md="3">
        <v-card class="kpi-card warning">
          <div class="kpi-value">$2.5M</div>
          <div class="kpi-label">تكاليف قصيرة الأجل</div>
        </v-card>
      </v-col>
      <v-col cols="12" sm="6" md="3">
        <v-card class="kpi-card primary">
          <div class="kpi-value">$1.7M</div>
          <div class="kpi-label">تكاليف طويلة الأجل</div>
        </v-card>
      </v-col>
      <v-col cols="12" sm="6" md="3">
        <v-card class="kpi-card danger">
          <div class="kpi-value">3</div>
          <div class="kpi-label">مرافق بأولوية عاجلة</div>
        </v-card>
      </v-col>
    </v-row>

    <!-- Table -->
    <v-card class="table-card" elevation="1">
      <div class="table-header">مصفوفة الأولوية والتكلفة التفصيلية</div>
      <v-table class="custom-table">
        <thead>
          <tr>
            <th>المرفق</th>
            <th>الهيكل</th>
            <th>الكهرباء</th>
            <th>WASH</th>
            <th>المعدات</th>
            <th>الإجمالي</th>
            <th>الأولوية</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="item in facilities" :key="item.name">
            <td class="font-weight-bold">{{ item.name }}</td>
            <td>{{ item.structure }}</td>
            <td>{{ item.electricity }}</td>
            <td>{{ item.wash }}</td>
            <td>{{ item.equipment }}</td>
            <td class="font-weight-bold">{{ item.total }}</td>
            <td>
              <v-chip
                :color="priorityColor(item.priority)"
                size="small"
                variant="flat"
              >
                {{ item.priority }}
              </v-chip>
            </td>
          </tr>
        </tbody>
      </v-table>
    </v-card>
  </v-container>
</template>

<script setup>
const facilities = [
  {
    name: "مستشفى الصداقة التعليمي",
    structure: "$620K",
    electricity: "$180K",
    wash: "$210K",
    equipment: "$230K",
    total: "$1,240K",
    priority: 32,
  },
  {
    name: "مستشفى الأمراض النفسية",
    structure: "$450K",
    electricity: "$120K",
    wash: "$160K",
    equipment: "$160K",
    total: "$890K",
    priority: 28,
  },
  {
    name: "مجمع الشيخ عثمان",
    structure: "$200K",
    electricity: "$80K",
    wash: "$70K",
    equipment: "$70K",
    total: "$420K",
    priority: 47,
  },
  {
    name: "مركز كود العثماني",
    structure: "$90K",
    electricity: "$30K",
    wash: "$30K",
    equipment: "$30K",
    total: "$180K",
    priority: 55,
  },
  {
    name: "مركز الممدارة",
    structure: "$40K",
    electricity: "$19K",
    wash: "$13K",
    equipment: "$23K",
    total: "$95K",
    priority: 68,
  },
  {
    name: "مركز المحاريق",
    structure: "$70K",
    electricity: "$32K",
    wash: "$23K",
    equipment: "$35K",
    total: "$160K",
    priority: 44,
  },
  {
    name: "مركز عبد القوي",
    structure: "$30K",
    electricity: "$15K",
    wash: "$10K",
    equipment: "$20K",
    total: "$75K",
    priority: 71,
  },
  {
    name: "مركز ماري ستبوس",
    structure: "$100K",
    electricity: "$40K",
    wash: "$30K",
    equipment: "$40K",
    total: "$210K",
    priority: 29,
  },
  {
    name: "جمعية حقوق الطفل",
    structure: "$18K",
    electricity: "$9K",
    wash: "$6K",
    equipment: "$12K",
    total: "$45K",
    priority: 74,
  },
];

const priorityColor = (value) => {
  if (value >= 65) return "green";
  if (value >= 40) return "orange";
  return "red";
};

const showView = (view) => {
  console.log("Go to:", view);
};
</script>

<style scoped>
.rtl {
  direction: rtl;
}

.header-card {
  border-right: 5px solid #4a4f55;
  border-radius: 18px;
  padding: 20px;
}

.kpi-card {
  border-radius: 18px;
  padding: 20px;
  text-align: center;
}

.kpi-value {
  font-size: 34px;
  font-weight: 800;
}

.kpi-label {
  margin-top: 6px;
  font-size: 13px;
}

.danger {
  background: #fdecea;
  color: #c0392b;
}

.warning {
  background: #fff4e5;
  color: #d4821a;
}

.primary {
  background: #f0f1f2;
  color: #4a4f55;
}

.table-card {
  border-radius: 18px;
  overflow: hidden;
}

.table-header {
  padding: 18px;
  font-size: 18px;
  font-weight: 700;
  color: #3a3f47;
  border-bottom: 1px solid #eee;
}

.custom-table {
  direction: rtl;
}

:deep(th) {
  font-weight: 800 !important;
  color: #3a3f47 !important;
  white-space: nowrap;
}

:deep(td) {
  font-size: 14px;
  white-space: nowrap;
}
</style>
